import IAnalyticsAction from "../IAnalyticsAction";
import {ActionType} from "typesafe-actions";
import {selectCard} from "../../../mini-games/cards/actions";

export default function selectCardHandler({ payload } : ActionType<typeof selectCard>): IAnalyticsAction | undefined {
    return {
        category: "map",
        object: "bonusgame",
        name: payload.isWon ? "win" : "lose",
        addition: "cards"
    };
}